// Generated by CoffeeScript 1.12.7

/*
  This module defines the block menu actions for the Project Editor context.
 */

(function () {
  var ColorWheel, Delete, FeatureFlag, Move, Save, Settings, ref;

  (ref = require("Common/Utils/ImageImports")),
    (Delete = ref.Delete),
    (Move = ref.Move),
    (Save = ref.Save),
    (ColorWheel = ref.ColorWheel),
    (Settings = ref.Settings);

  FeatureFlag = require("@CommonFrontendBackend/FeatureFlag")["default"];

  module.exports = function (
    settings,
    make,
    block,
    blockList,
    projectScrollTo,
    toggleCurrentTab,
    imageLocation,
    telemetry,
    access,
    usingFeature,
  ) {
    var actions, deleteBlock, saveBlock, settingsPanel, styleSelector;
    deleteBlock = make(require("./DeleteBlock/DeleteBlock"));
    saveBlock = make(require("./SaveBlock/SaveBlock"));
    styleSelector = make(require("./StyleSelector/StyleSelector"));
    settingsPanel = make(require("./Settings/Settings"), {
      settingItems: settings,
    });
    actions = [
      {
        name: "Settings",
        internal: "settings",
        displayType: "complex",
        description: "Settings for this block",
        event: "Clicked on block settings",
        icon: Settings,
        ui: settingsPanel.ui,
        ctrl: settingsPanel,
        enabled: true,
        onClick: (function (_this) {
          return function (item) {
            telemetry.track("Block Settings Viewed");
            return toggleCurrentTab(item);
          };
        })(this),
      },
      {
        name: "Block Styles",
        internal: "styles",
        displayType: "complex",
        description: "Change the style of this block",
        event: "Clicked on change styles",
        icon: ColorWheel,
        ui: styleSelector.ui,
        ctrl: styleSelector,
        enabled: access !== "view",
        onClick: (function (_this) {
          return function (item) {
            telemetry.track("Block Styles Viewed");
            return toggleCurrentTab(item);
          };
        })(this),
      },
      {
        name: "Save Block",
        internal: "save",
        displayType: "complex",
        description: "Save this content for later",
        event: "Clicked on save block",
        icon: Save,
        ui: saveBlock.ui,
        ctrl: saveBlock,
        enabled: access !== "view",
        onClick: toggleCurrentTab,
      },
    ];
    return actions;
  };
}.call(this));
